<template>
  <StudioMultiSelect
    v-model="selected"
    :searchable="searchable"
    :items="selectItems"
    :label="computedLabel"
    :placeholder="computedPlaceholder"
    :clearable="showClearable"
    @clearClick="$emit('clearInfo', computedLabel)"
  >
    <template v-slot:selection="{item, index}">
      <span
        v-if="index === 0 && selected.length === selectItems.length"
        class="repliers-filter__summary text--disabled"
      >
        {{ $t('components.filters.RepliersFilter.indifferent') }}
      </span>
      <template
        v-else-if="selected.length !== selectItems.length"
      >
        <v-chip
          v-if="index < minimumFilterView"
          small
        >
          <span>{{ getText(item) }}</span>
        </v-chip>
        <span
          v-if="index === minimumFilterView"
          class="grey--text caption"
        >
          (+{{ selected.length - minimumFilterView }} {{ message }})
        </span>
      </template>
    </template>
  </StudioMultiSelect>
</template>

<script>
import StudioMultiSelect from '@/components/filter/models/StudioMultiSelect';

export default {
  name: 'RepliersFilter',
  components: {
    StudioMultiSelect,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    selectItems: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: null,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      minimumFilterView: 1,
    };
  },
  computed: {
    selected: {
      get() {
        // When select all options, we filter data with repliers and without repliers
        // (sending nothing, but show as all selected)
        if (!this.value) {
          return [...this.selectItems];
        }

        const value = this.value && this.value.value;

        // When selection is empty, we filter data without replier
        // (sending empty array and show nothing select)
        if (value && value.length === 0) {
          return [];
        }

        return value;
      },
      set(newValue) {
        // When selection is empty, we filter data without replier
        // (sending empty array and show nothing select)
        if (newValue && newValue.length === 0) {
          return this.$emit('input', {
            value: [],
          });
        }

        // When select all options, we filter data with repliers and without repliers
        // (sending nothing, but show as all selected)
        if (newValue.length === this.selectItems.length) {
          return this.$emit('input', undefined);
        }

        // When select some options, we filter data only with the selected repliers
        this.$emit('input', {
          value: newValue.map(v => v),
        });
      },
    },
    message() {
      return this.selected.length - this.minimumFilterView === 1
        ? this.$t('components.filters.RepliersFilter.other')
        : this.$t('components.filters.RepliersFilter.others');
    },
    computedLabel() {
      return this.label !== null ? this.label : this.$t('components.filters.RepliersFilter.label');
    },
    computedPlaceholder() {
      return this.placeholder !== null ? this.placeholder : this.$t('components.filters.RepliersFilter.placeholder');
    },
    showClearable() {
      return Boolean(this.clearable && (this.selected.length !== this.selectItems.length));
    },
  },
  methods: {
    getText(item) {
      return typeof item === 'object' ? item.text : item;
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }

  .repliers-filter__summary {
    font-size: 14px;
  }
</style>
